import { createSelector } from 'reselect';
import { getMaintainSelectedLimits, getSelectedOrganization, getTrendDataSelector } from '../TrendChart/selectors';
import { getTrendKPIsList } from '../TrendKPIList/selectors';
import { getEnergyRelatedKPIsList } from '../EnergyRelatedSignalsList/selectors';

import { getActiveDetailedInformationTabV2 } from '../../../selectors';

const getAssetDetails = ({ powertrainAssetDetails }) => {
    return powertrainAssetDetails.selectedAsset;
};

const getSelectedTrendKPIs = ({ operationalParameters }) => {
    return operationalParameters?.preselectedKPIs?.single?.trend;
};

const getSelectedLimits = ({ operationalParameters }) => {
    return operationalParameters?.selectedLimits;
};

const getSelectedLimitsAction = ({ operationalParameters }) => {
    return operationalParameters?.selectedLimitsAction;
};

const getAssetActiveTab = ({ detailedInformation }) => {
    return detailedInformation?.activeTab;
};

const getIsDefaultLimitsSelected = ({ operationalParameters }) => {
    return operationalParameters?.isDefaultLimitsSelected;
};

export const getModel = createSelector([
    getAssetDetails,
    getSelectedTrendKPIs,
    getEnergyRelatedKPIsList,
    getTrendKPIsList,
    getSelectedLimits,
    getSelectedLimitsAction,
    getAssetActiveTab,
    getTrendDataSelector,
    getIsDefaultLimitsSelected,
    getSelectedOrganization,
    getMaintainSelectedLimits,
    getActiveDetailedInformationTabV2
], (
    selectedAsset,
    selectedTrendKPIs,
    energyRelatedKPIsList,
    trendKPIsList,
    selectedLimits,
    selectedLimitsAction,
    assetActiveTab,
    selectedTrendsData,
    isDefaultLimitsSelected,
    selectedOrganization,
    maintainSelectedLimits,
    activeTabV2
) => {
    const allKPIsList = [...trendKPIsList || [], ...energyRelatedKPIsList || []];
    return {
        selectedAsset,
        selectedTrendKPIs,
        trendKPIsList: allKPIsList,
        selectedLimits,
        selectedLimitsAction,
        assetActiveTab,
        selectedTrendsData,
        isDefaultLimitsSelected,
        selectedOrganization,
        maintainSelectedLimits,
        activeTabV2
    };
});
